var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 3.58332L14.7333 11.9375C14.6017 14.0717 14.5358 15.1392 14 15.9067C13.7355 16.286 13.3949 16.6061 13 16.8467C12.2025 17.3333 11.1333 17.3333 8.995 17.3333C6.85333 17.3333 5.7825 17.3333 4.98333 16.8458C4.58824 16.6048 4.24768 16.2841 3.98333 15.9042C3.44833 15.1358 3.38333 14.0667 3.255 11.9292L2.75 3.58332M1.5 3.58332H16.5M12.38 3.58332L11.8108 2.40999C11.4333 1.62999 11.2442 1.24082 10.9183 0.99749C10.846 0.943586 10.7693 0.895651 10.6892 0.854156C10.3283 0.666656 9.895 0.666656 9.02917 0.666656C8.14083 0.666656 7.69667 0.666656 7.32917 0.861656C7.24793 0.905166 7.17044 0.955338 7.0975 1.01166C6.76833 1.26416 6.58417 1.66832 6.21583 2.47582L5.71083 3.58332M6.91667 12.75V7.74999M11.0833 12.75V7.74999",
    stroke: "#E85E5E",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteSegment);
export default __webpack_public_path__ + "static/media/icon-delete-segment.68118f881867e683e69ab38918e0234f.svg";
export { ForwardRef as ReactComponent };